import reducer from 'state/mrDistribution/quote/reducer';
import actions from 'state/mrDistribution/quote/actionCreators';
import selectors from 'state/mrDistribution/quote/selectors';

export { actions, selectors };

export default reducer;
